var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentViewed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 54.59 64.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:#fff;}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1514.36,
    y1: 18.03,
    x2: -1513.57,
    y2: 17.45,
    gradientTransform: "matrix(42.82, 0, 0, -58.55, 64854.82, 1075.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45a2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1514.01,
    y1: -33.96,
    x2: -1514.01,
    y2: -34.31,
    gradientTransform: "matrix(42.82, 0, 0, -12.37, 64854.81, -360.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174461",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1326.44,
    y1: 16.28,
    x2: -1327.56,
    y2: 16.3,
    gradientTransform: "matrix(6.94, 0, 0, -52.9, 9257.01, 893.82)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1495.09,
    y1: 11.95,
    x2: -1495.23,
    y2: 12.16,
    gradientTransform: "matrix(28.32, 0, 0, -41.73, 42381.23, 544.49)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1514.36,
    y1: 18.03,
    x2: -1513.57,
    y2: 17.46,
    gradientTransform: "matrix(42.82, 0, 0, -58.56, 64846.55, 1073.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1514,
    y1: -44.79,
    x2: -1514,
    y2: -45.08,
    gradientTransform: "matrix(42.82, 0, 0, -10.63, 64846.55, -417.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1509.41,
    y1: -160.07,
    x2: -1509.42,
    y2: -158.56,
    gradientTransform: "matrix(38, 0, 0, -4.24, 57381.54, -616.21)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1514.26,
    y1: 18,
    x2: -1513.45,
    y2: 17.19,
    gradientTransform: "matrix(42.82, 0, 0, -58.44, 64853.07, 1066.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7acbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1513.46,
    y1: 16.96,
    x2: -1514.8,
    y2: 18,
    gradientTransform: "matrix(42.73, 0, 0, -55.29, 64710.56, 965.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1427.48,
    y1: -32.96,
    x2: -1426.81,
    y2: -33.63,
    gradientTransform: "matrix(12.63, 0, 0, -12.53, 18033.8, -407.52)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1514.01,
    y1: -80.7,
    x2: -1514.01,
    y2: -81.49,
    gradientTransform: "matrix(42.82, 0, 0, -7.2, 64851.52, -527.59)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1494.97,
    y1: 12.15,
    x2: -1495.48,
    y2: 12.44,
    gradientTransform: "matrix(28.32, 0, 0, -41.73, 42381.23, 544.58)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1504.26,
    y1: -3.46,
    x2: -1503.82,
    y2: -4.11,
    gradientTransform: "matrix(33.61, 0, 0, -22.93, 50587.81, -59.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1473.11,
    y1: -8.81,
    x2: -1474.74,
    y2: -7.18,
    gradientTransform: "matrix(20.19, 0, 0, -20.19, 29779.86, -146)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1456.2,
    y1: -17.42,
    x2: -1455.55,
    y2: -18.06,
    gradientTransform: "matrix(16.46, 0, 0, -16.46, 24006.84, -263.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content_viewed",
    "data-name": "content viewed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50742",
    "data-name": "Group 50742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50734",
    "data-name": "Group 50734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67472",
    "data-name": "Path 67472",
    className: "cls-1",
    d: "M10.56,64.09H45.72a3.83,3.83,0,0,0,3.83-3.83V9.37a3.83,3.83,0,0,0-3.83-3.83H10.56A3.82,3.82,0,0,0,6.73,9.37h0v50.9A3.82,3.82,0,0,0,10.56,64.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67473",
    "data-name": "Path 67473",
    className: "cls-2",
    d: "M6.73,51.72v8.54a3.82,3.82,0,0,0,3.83,3.83H45.72a3.83,3.83,0,0,0,3.83-3.83h0V51.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67474",
    "data-name": "Path 67474",
    className: "cls-3",
    d: "M45.72,5.54H42.6v52.9h6.95V9.37a3.83,3.83,0,0,0-3.83-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67475",
    "data-name": "Path 67475",
    className: "cls-4",
    d: "M21.82,24.05a3.33,3.33,0,0,0,0,3.79A24,24,0,0,0,25,31.91L49.55,56.47V19.07a18.13,18.13,0,0,0-11.77-4.33C31.36,14.74,25.83,18.18,21.82,24.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50735",
    "data-name": "Group 50735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67476",
    "data-name": "Path 67476",
    className: "cls-5",
    d: "M3.83,61.88H39a3.83,3.83,0,0,0,3.83-3.83h0V7.15A3.84,3.84,0,0,0,39,3.32H3.83A3.83,3.83,0,0,0,0,7.15v50.9a3.82,3.82,0,0,0,3.83,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67477",
    "data-name": "Path 67477",
    className: "cls-6",
    d: "M0,51.24V58a3.82,3.82,0,0,0,3.83,3.83H39A3.83,3.83,0,0,0,42.82,58h0v-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67478",
    "data-name": "Path 67478",
    className: "cls-7",
    d: "M4.82,57.64l4.24,4.24H39a3.84,3.84,0,0,0,3.83-3.83h0v-.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50741",
    "data-name": "Group 50741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67479",
    "data-name": "Path 67479",
    className: "cls-8",
    d: "M42.6,0H16.89a4.24,4.24,0,0,0-3,1.24L4.68,10.46a4.2,4.2,0,0,0-1.24,3V54.79a3.66,3.66,0,0,0,3.65,3.65H42.6a3.67,3.67,0,0,0,3.66-3.65V3.65A3.67,3.67,0,0,0,42.6,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50740",
    "data-name": "Group 50740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50739",
    "data-name": "Group 50739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50736",
    "data-name": "Group 50736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67480",
    "data-name": "Path 67480",
    className: "cls-9",
    d: "M19.07,29.22H10.26a1.17,1.17,0,0,1-1.17-1.17h0V25.71a1.18,1.18,0,0,1,1.17-1.17h8.81a1.17,1.17,0,0,1,1.17,1.17h0v2.34a1.17,1.17,0,0,1-1.17,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67481",
    "data-name": "Path 67481",
    className: "cls-9",
    d: "M39.43,29.22H24.05a1.17,1.17,0,0,1-1.17-1.17h0V25.71a1.17,1.17,0,0,1,1.17-1.17H39.43a1.17,1.17,0,0,1,1.17,1.17h0v2.34a1.17,1.17,0,0,1-1.17,1.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50737",
    "data-name": "Group 50737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67482",
    "data-name": "Path 67482",
    className: "cls-9",
    d: "M30.62,36.26h8.81A1.16,1.16,0,0,0,40.6,35.1h0V32.76a1.17,1.17,0,0,0-1.17-1.17H30.62a1.17,1.17,0,0,0-1.17,1.17h0v2.33a1.17,1.17,0,0,0,1.17,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67483",
    "data-name": "Path 67483",
    className: "cls-9",
    d: "M10.26,36.26H25.65a1.16,1.16,0,0,0,1.16-1.17h0V32.76a1.16,1.16,0,0,0-1.16-1.17H10.26a1.17,1.17,0,0,0-1.17,1.17h0v2.33a1.17,1.17,0,0,0,1.17,1.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50738",
    "data-name": "Group 50738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67484",
    "data-name": "Path 67484",
    className: "cls-9",
    d: "M19.07,43.31H10.26a1.17,1.17,0,0,1-1.17-1.17h0V39.8a1.18,1.18,0,0,1,1.17-1.17h8.81a1.17,1.17,0,0,1,1.17,1.17h0v2.34a1.17,1.17,0,0,1-1.17,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67485",
    "data-name": "Path 67485",
    className: "cls-9",
    d: "M39.43,43.31H24.05a1.17,1.17,0,0,1-1.17-1.17h0V39.8a1.17,1.17,0,0,1,1.17-1.17H39.43A1.17,1.17,0,0,1,40.6,39.8h0v2.34a1.17,1.17,0,0,1-1.17,1.17Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_67486",
    "data-name": "Path 67486",
    className: "cls-10",
    d: "M46.25,54.79V3.65A3.66,3.66,0,0,0,42.6,0H16.89a4.24,4.24,0,0,0-3,1.24L4.68,10.46A4.16,4.16,0,0,0,3.53,12.6L46.22,55.29A4.07,4.07,0,0,0,46.25,54.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67487",
    "data-name": "Path 67487",
    className: "cls-11",
    d: "M3.56,12.43l0,.17H14.71a1.43,1.43,0,0,0,1.44-1.43h0V.07l-.27,0a4.45,4.45,0,0,0-2.2,1.22l-8.9,8.9A4.63,4.63,0,0,0,3.56,12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67488",
    "data-name": "Path 67488",
    className: "cls-12",
    d: "M3.44,51.24v3.55a3.66,3.66,0,0,0,3.65,3.65H42.6a3.67,3.67,0,0,0,3.66-3.65V51.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_67489",
    "data-name": "Path 67489",
    className: "cls-13",
    d: "M49.54,19.07a18.05,18.05,0,0,0-11.76-4.33c-6.42,0-12,3.43-16,9.31a3.33,3.33,0,0,0,0,3.79A24,24,0,0,0,25,31.91L49.55,56.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50744",
    "data-name": "Group 50744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50743",
    "data-name": "Group 50743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67490",
    "data-name": "Path 67490",
    className: "cls-14",
    d: "M37.78,14.48c-6.42,0-12.2,3.69-16.22,9.57a3.36,3.36,0,0,0,0,3.79c4,5.88,9.8,9.57,16.22,9.57S50,33.72,54,27.84a3.36,3.36,0,0,0,0-3.79C50,18.17,44.21,14.48,37.78,14.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4840",
    "data-name": "Ellipse 4840",
    className: "cls-15",
    cx: 37.78,
    cy: 25.95,
    r: 10.09
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4841",
    "data-name": "Ellipse 4841",
    className: "cls-16",
    cx: 37.78,
    cy: 25.95,
    r: 8.23
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentViewed);
export default __webpack_public_path__ + "static/media/content-viewed.8bcbc10bc71171aa3d9d1668304a337c.svg";
export { ForwardRef as ReactComponent };